document.addEventListener('DOMContentLoaded', function() {
    // FAQ Sidebar functionality
    (function() {
    const sidebar = document.querySelector('.faq__sidebar');
    if (!sidebar) return;

    const categoryLinks = sidebar.querySelectorAll('.faq__toc-item');
    const categories = [];

    categoryLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
        const element = document.getElementById(href.substring(1));
        if (element) {
            categories.push({ link, element });
        }
        }
    });

    if (categories.length === 0) return;

    const SCROLL_OFFSET = 30; // Spacing from top of window when scrolling to section

    // Smooth scroll on click
    categoryLinks.forEach(link => {
        link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const href = this.getAttribute('href');
        if (href && href.startsWith('#')) {
            const targetElement = document.getElementById(href.substring(1));
            
            if (targetElement) {
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - SCROLL_OFFSET;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
            }
        }
        });
    });

    // Update active link on scroll
    function updateActiveLink() {
        const scrollPosition = window.pageYOffset;
        const triggerPoint = scrollPosition + 100; // Adjust trigger threshold
        let activeIndex = -1;

        // Loop through categories to find which one is in view
        for (let i = categories.length - 1; i >= 0; i--) {
        const elementTop = categories[i].element.getBoundingClientRect().top + scrollPosition;
        
        if (triggerPoint >= elementTop) {
            activeIndex = i;
            break;
        }
        }

        // If no category found (scrolled to very top), activate first one
        if (activeIndex === -1) {
        activeIndex = 0;
        }

        categories.forEach((cat, index) => {
        cat.link.classList.toggle('is-active', index === activeIndex);
        });
    }

    window.addEventListener('scroll', updateActiveLink, { passive: true });
    
    // Initial check
    setTimeout(updateActiveLink, 100);
    })();
});